"use client";

export default function WhenYouNeed() {
  const cards = [
    {
      icon: "ri-cloud-windy-line",
      title: "After Storm",
      desc: "Hurricane debris, branches, wind damage.",
    },
    {
      icon: "ri-door-lock-line",
      title: "After Break-In",
      desc: "Forced entry. Secure before insurance.",
    },
    {
      icon: "ri-car-washing-line",
      title: "Accidental Damage",
      desc: "Ball, vehicle impact, falling objects.",
    },
    {
      icon: "ri-time-line",
      title: "Awaiting Repair",
      desc: "Glass on order. Secure meanwhile.",
    },
  ];

  return (
    <section className="bg-cream py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-[32px] font-bold text-secondary text-center mb-12">
          When to Call for Board-Up
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((c) => (
            <div
              key={c.title}
              className="bg-white rounded-xl border-t-4 border-primary p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary/10 text-primary mb-4">
                <i className={`${c.icon} text-xl`} />
              </div>
              <h3 className="text-lg font-bold text-secondary mb-2">{c.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}